import React, { useEffect, useState, useCallback } from 'react'
import classNames from 'classnames'

import { Image } from '../../components/Image/Image'
import { GameWrapper } from '../../components/GameWrapper/GameWrapper'
import { CustomDnd } from '../../components/CustomDnd/CustomDnd'
import cleanMapImg from '../../resources/cleanMap.png'

import styles from './GameShadow.module.scss'
import shadow00Img from './shadow-00.png'
import shadow01Img from './shadow-01.png'
import shadow02Img from './shadow-02.png'
import shadow03Img from './shadow-03.png'
import shadow04Img from './shadow-04.png'
import building00Img from './building-00.png'
import building01Img from './building-01.png'
import building02Img from './building-02.png'
import building03Img from './building-03.png'
import building04Img from './building-04.png'

const SHADOW_IMG_LIST = [
    shadow00Img,
    shadow01Img,
    shadow02Img,
    shadow03Img,
    shadow04Img,
]

const BUILDING_IMG_LIST = [
    building00Img,
    building01Img,
    building02Img,
    building03Img,
    building04Img,
]

function GameShadow() {
    const [win, setWin] = useState(false)
    const [doneParts, setDoneParts] = useState([])

    const onDrop = useCallback((draggable, droppable) => {
        if (draggable === droppable && !doneParts.includes(draggable)) {
            setDoneParts([...doneParts, draggable])
        }
    }, [doneParts, setDoneParts])

    useEffect(() => {
        if (doneParts.length === BUILDING_IMG_LIST.length) {
            setWin(true)
        }
    }, [doneParts, setWin])

    return (
        <GameWrapper win={win} people="1">
            <CustomDnd onDropped={onDrop} className={styles.customDnd}>
                <Image src={cleanMapImg} className={styles.bg} />

                {
                    BUILDING_IMG_LIST.map((img, index) => (
                        doneParts.includes(index.toString())
                            ? (
                                <Image
                                    key={img}
                                    src={img}
                                    className={classNames(`building-0${index}`, styles.done)}
                                />
                            )
                            : (
                                <div key={img} />
                            )
                    ))
                }

                {
                    SHADOW_IMG_LIST.map((img, index) => (
                        doneParts.includes(index.toString())
                            ? (
                                <div key={img} />
                            )
                            : (
                                <Image
                                    key={img}
                                    src={img}
                                    className={classNames(`building-0${index}`, styles.dropZone)}
                                    droppable={index.toString()}
                                />
                            )
                    ))
                }

                {
                    BUILDING_IMG_LIST.map((img, index) => (
                        doneParts.includes(index.toString())
                            ? (
                                <div key={img} />
                            )
                            : (
                                <Image
                                    key={img}
                                    src={img}
                                    className={`building-0${index}`}
                                    draggable={index.toString()}
                                />
                            )
                    ))
                }
            </CustomDnd>
        </GameWrapper>
    )
}

GameShadow.propTypes = {}

export { GameShadow }
